// Dispara os eventos 'AddPaymentInfo'
function dispatchPaymentInfo() {
  dispatchPixelEvent('facebook', 'AddPaymentInfo');
  dispatchPixelEvent('tiktok', 'AddPaymentInfo');
  dispatchPixelEvent('analytics', 'add_payment_info');
}

// Dispara um evento do pixel
function dispatchPixelEvent(service, eventName) {
  let pxEventDispatched = false;
  if (!previewMode) {
    // Verifica se o pixel já foi disparado
    if (!verifyPixelEvent(service, eventName, cartToken)) {
      // AddPaymentInfo
      if ((eventName === 'AddPaymentInfo' || eventName === 'add_payment_info') && validateAddPaymentInfo()) {
        // Facebook
        if (service === 'facebook' && typeof fbq === 'function') {
          const pixels = $('.co-payment').data('fb-pixels');
          if (pixels && Object.keys(pixels).length > 0) {
            Object.keys(pixels).forEach((i) => {
              const px = pixels[i];
              if (px.processing_mode == 'api') {
                setTimeout(() => {
                  dispatchPayInfoAPI(px);
                }, 500);
              }
              fbq('trackSingle', '' + px.id + '', 'AddPaymentInfo', px.infos, { eventID: px.event_id });
            });
          }
          pxEventDispatched = true;
        }
        // Tiktok
        else if (service === 'tiktok' && typeof ttq === 'object') {
          ttq.track('AddPaymentInfo');
          pxEventDispatched = true;
        }
        // Google Analytics
        else if (service === 'analytics') {
          const pixelInfos = $('.co-payment').data('ana-pixels');
          const paymentMehod = getOption('payment_title')
            ? getOption('payment_title')
            : $('.payment-item input[name="payment_method"]:checked').data('title');
          if (pixelInfos && Object.keys(pixelInfos).length > 0) {
            if (typeof gtag !== 'undefined') {
              gtag('event', 'add_payment_info', {
                currency: pixelInfos.currency,
                value: pixelInfos.value,
                payment_type: paymentMehod,
                items: pixelInfos.items,
              });
            } else if (typeof dataLayer !== 'undefined') {
              dataLayer.push({
                event: 'add_payment_info',
                ecommerce: {
                  currency: pixelInfos.currency,
                  value: pixelInfos.value,
                  payment_type: paymentMehod,
                  items: pixelInfos.items,
                },
              });
            }
            pxEventDispatched = true;
          }
        }
      }
      if (pxEventDispatched) {
        storePixelEvent(service, eventName, cartToken);
        console.log(`Pixel (${service}): '${eventName}' disparado.`);
      }
    } else {
      console.log(`Pixel (${service}): '${eventName}' já foi disparado.`);
    }
  }
}

// Verifica se um evento já foi disparado para o mesmo checkout (carrinho)
function verifyPixelEvent(service, event, identification) {
  const cookieKey = `${service}-${event}-${identification}`;
  return getCookie(cookieKey);
}
/* function dispatchedPixelEvent(service, eventName) {
  let pxEventsList = localStorage.getItem('lpqv_px_events');
  if (pxEventsList) {
    pxEventsList = JSON.parse(pxEventsList);
    return pxEventsList.some(
      (item) => item.service === service && item.event === eventName && item.cart_token === cartToken,
    );
  }
  return false;
} */

// Salva um evento já disparado
function storePixelEvent(service, event, identification) {
  const cookieKey = `${service}-${event}-${identification}`;
  const cookieVal = new Date().getTime();
  setCookie(cookieKey, cookieVal, 7);
}
/* function savePixelEvent(service, eventName) {
  let pxEventsList = localStorage.getItem('lpqv_px_events');
  if (!pxEventsList) {
    pxEventsList = [];
  } else {
    pxEventsList = JSON.parse(pxEventsList);
  }
  const pxEventObj = {
    service: service,
    event: eventName,
    cart_token: cartToken,
  };
  pxEventsList.push(pxEventObj);
  localStorage.setItem('lpqv_px_events', JSON.stringify(pxEventsList));
} */

// Verifica se já é possível disparar o evento 'AddPaymentInfo' (Só dispara se já tiver preenchido o e-mail e selecioado uma forma de pagamento)
function validateAddPaymentInfo() {
  let isValid = false;
  if (!checkoutStepsEnable) {
    isValid =
      $('#co-email').val() != '' &&
      ($('.payment-item input[name="payment_method"]:checked').val() != '' ||
        $('.co-payment-tabs-input[name="payment_method"]:checked').val() != '');
  } else {
    isValid = $('#co-email').val() != '';
  }
  return isValid;
}

// Dispara a ação para acionar o evento 'AddPaymentInfo' do Facebook (Via API)
function dispatchPayInfoAPI(pixel) {
  const urlAction = urlBase + 'core/acoes/checkout/facebook_pixel_payinfo.php';
  let name = $('#co-name').val();
  let firstName;
  let lastName;
  if (name != '' && name.trim() != '') {
    const nameArr = name.trim().toLowerCase().split(' ');
    firstName = nameArr[0];
    lastName = nameArr[nameArr.length - 1];
  }
  const data = {
    pixel_id: pixel.id,
    event_id: pixel.event_id,
    pixel_infos: pixel.infos,
    pixel_token: pixel.token,
    fbclid: pixel.fbclid,
    pag_url: window.location.origin + window.location.pathname,
  };
  if (firstName) data.firstname = firstName;
  if (lastName) data.lastName = lastName;
  if ($('#co-email').val() != '') data.email = $('#co-email').val();
  if ($('#co-phone').val() != '') data.phone = $('#co-phone').val();
  if ($('#co-city').val() != '') data.city = $('#co-city').val();
  if ($('#co-state').val() != '') data.state = $('#co-state').val();
  if ($('#co-zipcode').val() != '') data.zip_code = $('#co-zipcode').val();
  $.ajax({
    url: urlAction,
    type: 'POST',
    data: data,
  })
    .done(function (result) {
      if (result != 'success') {
        console.log('Facebook Pixel API Error: ' + result);
      }
    })
    .fail(function (jqXHR, textStatus, error) {
      console.log(error);
    });
}
